import { render } from "./CatalogIndex.vue?vue&type=template&id=7e30a364&scoped=true"
import script from "./CatalogIndex.vue?vue&type=script&lang=js"
export * from "./CatalogIndex.vue?vue&type=script&lang=js"

import "./CatalogIndex.vue?vue&type=style&index=0&id=7e30a364&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e30a364"]])

export default __exports__